import React, { FC } from 'react';
import { StyledChip } from './styled';
import { CustomChipProps } from './types';

const CustomChip: FC<CustomChipProps> = (props) => {
  return <StyledChip size={'small'} {...props} />;
};

export default CustomChip;
